// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:39:27

export default {
  "id": "merge-galaxy",
  "slug": "merge-galaxy",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e78a30e2939b4bdab5ce70ac3c19f2f2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e78a30e2939b4bdab5ce70ac3c19f2f2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Galaxy",
      "description": "The famous merge game is arrived!\nYou can shoot the planets like balls to throw, and when the same planets touch each other, it becomes bigger planet!\nCute planets want to be bigger, so keep merge the planets until you make the sun!",
      "instructions": "When small planets touch each other, they become bigger planets\nIf you calculate the gravity to position the planets, it will help you to put the planets in the right spots.\nAt random timing, you can use extra help from strolling space ship, Space Tornado or 'Beyond space' button after you click them.",
      "genres": [
        "Merge"
      ],
      "tags": [
        "galaxy",
        "gravity",
        "matching",
        "physics",
        "throwing"
      ]
    },
    "zh-CN": {
      "title": "融合星系",
      "description": "著名合并游戏已上线！\n你可以像扔球一样射击行星，当相同的行星相互接触时，它会变成更大的行星！\n可爱的行星想要变得更大，所以继续合并行星，直到你制造出太阳！",
      "instructions": "当小行星相撞时，它们会变成更大的行星。\n如果你计算引力以定位行星，这将帮助你将行星放置在正确的位置。\n在随机时间，点击后，你可以使用漫游太空船、太空旋风或“超越空间”按钮来获得额外帮助。",
      "genres": [
        "合并"
      ],
      "tags": [
        "银河",
        "重力",
        "匹配",
        "物理",
        "投掷"
      ]
    },
    "zh-TW": {
      "title": "合併星系",
      "description": "著名合併遊戲來臨了！\n你可以像射球一樣射擊行星，當相同的行星觸碰到彼此時，它就會變得更大成為行星！\n可愛的行星想要變得更大，所以繼續合併行星，直到你製造出太陽！",
      "instructions": "當小行星碰触彼此時，它們會變成大行星。\n如果你計算引力來定位行星，這將幫助你將行星放在正確的位置。\n在隨機時間，你可以在點擊它們後使用巡遊太空船、太空颱風或「超越太空」按鈕的額外幫助。",
      "genres": [
        "合併"
      ],
      "tags": [
        "銀河",
        "重力",
        "配對",
        "物理",
        "拋投"
      ]
    },
    "zh-HK": {
      "title": "合併星系",
      "description": "經典合併遊戲來臨啦！\n你可以將行星當作球來射擊，當相同的行星碰到一起時，它就會變得更大成為行星！\n可愛的行星們想要變大，所以繼續合併行星，直到你合併出太陽！",
      "instructions": "當小行星觸碰時，它們會變成更大的行星。\n如果你計算引力以定位行星，將有助於你將行星放在正確的位置。\n隨機時間，你可在點擊後使用巡遊太空船、太空颱風或「超越空間」按鈕的額外幫助。",
      "genres": [
        "合併"
      ],
      "tags": [
        "銀河",
        "引力",
        "配對",
        "物理學",
        "投擲"
      ]
    },
    "ja": {
      "title": "ガラクシー合体",
      "description": "有名なマージゲームが登場です！\n惑星をボールのように撃って投げることができます。同じ惑星が触れ合うと、より大きな惑星に变大します！\n可愛い惑星は大きくなりたいですので、太陽を作るまで惑星をマージし続けてください！",
      "instructions": "小惑星が触れ合うと、大きな惑星になります。\n惑星の重力を計算して配置することで、惑星を正しい場所に配置するのに役立ちます。\nランダムなタイミングで、スペーストレイン、スペーストornado、または「ベイビースペース」ボタンをクリックした後、追加のサポートを使用できます。",
      "genres": [
        "合体"
      ],
      "tags": [
        "銀河",
        "重力",
        "一致",
        "物理",
        "投げる"
      ]
    },
    "ko": {
      "title": "계합galaxy",
      "description": "유명한 합성 게임이 도착했습니다!\n행성을 공처럼 쏘아서 던져서, 같은 행성이 만나면 더 큰 행성으로 커집니다!\n좋아하는 행성들은 더 커지고 싶어서, 태양을 만들까지 행성들을 합성해주세요!",
      "instructions": "소행성이 서로 만나면 더 큰 행성이 됩니다.\n행성의 중력을 계산하여 위치를 정하면 행성을 올바른 위치에 배치하는 데 도움이 됩니다.\n무작위 시간에, 스탭 스페이스 셔프, 스페이스 토너도 또는 '빠른 공간' 버튼을 클릭한 후 추가 도움을 받을 수 있습니다.",
      "genres": [
        "병합"
      ],
      "tags": [
        "가칭",
        "중력",
        "매칭",
        "물리학",
        "던지기"
      ]
    },
    "fr": {
      "title": "Fusion Galaxie",
      "description": "Le célèbre jeu de fusion est arrivé !\nVous pouvez tirer les planètes comme des balles pour les lancer, et quand des planètes identiques se touchent, elles deviennent une planète plus grande !\nLes planètes mignonnes veulent devenir plus grandes, donc continuez à fusionner les planètes jusqu'à ce que vous fassiez le soleil !",
      "instructions": "Quand de petites planètes se touchent, elles deviennent de grandes planètes.\nSi vous calculez la gravité pour positionner les planètes, cela vous aidera à les placer aux bons endroits.\nÀ des moments aléatoires, vous pouvez utiliser une aide supplémentaire de l'astronef de promenade, de la Tempête spatiale ou du bouton 'Au-delà de l'espace' après avoir cliqué dessus.",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "galaxie",
        "gravité",
        "correspondance",
        "physique",
        "lancer"
      ]
    }
  }
};
